export const CONFIGURABLE_PRODUCTS_LINE_ITEM_UUID_CHILD_KEY = "_configurable_products_parent_uuid";
export const CONFIGURABLE_PRODUCTS_LINE_ITEM_UUID_PARENT_KEY = "_configurable_products_uuid";
export const CONFIGURABLE_PRODUCTS_LINE_ITEM_PARENT_LIST_KEY = "configurable_products";
export const CONFIGURABLE_PRODUCTS_LINE_ITEM_IS_CONFIGURABLE_KEY = "_is_configurable_product";